import React from "react";
import styles from "./CustomerServiceSimulator.module.css";
import UserSection from "./components/UserSection";
import CustomerServiceSection from "./components/CustomerServiceSection";
import { ChatBotProvider } from "react-chatbotify";
import AssetsPack from "../../../util/AssetsPack";
import { useNavigate } from "react-router-dom";

interface CustomerServiceProps {}

const CustomerService: React.FC<CustomerServiceProps> = ({}) => {
  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate("/newManager");
  };

  const handleRagChatClicked = () => {
    navigate("/chatbot");
  };

  return (
    <ChatBotProvider>
      <div className={styles["container"]}>
        <div className={styles["top-nav"]}>
          <div className={styles["left-side"]}>
            <button
              className={styles["back-button"]}
              onClick={handleBackButton}
            >
              <img
                src={AssetsPack.icons.ICON_BACK.default}
                className={styles["back-button-icon"]}
              />{" "}
              Go Back
            </button>
          </div>
          <div className={styles["right-side"]}>
            <button
              className={styles["back-button"]}
              onClick={handleRagChatClicked}
            >
              <img
                src={AssetsPack.icons.ICON_CUSTOMER_SUPPORT.default}
                className={styles["rag-icon"]}
              />{" "}
              Rag Test
            </button>
          </div>
        </div>
        <div className={styles["main-section"]}>
          <div className={styles["user-section"]}>
            <UserSection />
          </div>
          <div className={styles["customer-service-section"]}>
            <CustomerServiceSection />
          </div>
        </div>
      </div>
    </ChatBotProvider>
  );
};

export default CustomerService;
